var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdasIntelligenceLoginLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.21 62.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #78c2ea;\n      }\n\n      .st1 {\n        fill: #f1f2f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 52.35,
    cy: 19.26,
    r: 3.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.63,9.18c-.7,0-1.37-.13-1.99-.35v14.84c0,2.71-1.93,4.11-3.58,4.49-1.65.38-4-.05-5.18-2.49l-10.02-20.71c-1.42-2.94-4.34-4.78-7.6-4.8-.02,0-.04,0-.06,0-3.24,0-6.15,1.8-7.61,4.7l-13.44,26.85h4.52l12.53-25.05c.77-1.55,2.27-2.47,4-2.47.01,0,.02,0,.03,0,1.74.01,3.24.96,4,2.52l10.02,20.71c1.79,3.71,5.7,5.58,9.71,4.66,4.02-.92,6.71-4.31,6.71-8.43v-14.86c-.64.24-1.32.37-2.04.37Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 80.63,
    cy: 3.27,
    r: 3.27
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.16,59.98H.48l3.06-7.75c.32-.81.92-1.12,1.83-1.12s1.5.31,1.81,1.12l2.94,7.75h-1.69l-2.65-7.01c-.08-.21-.22-.3-.43-.3s-.35.09-.44.3l-2.76,7.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5.3,
    cy: 57.04,
    r: 1.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.11,59.98h-1.68l3.06-7.75c.32-.81.92-1.12,1.83-1.12s1.5.31,1.81,1.12l2.94,7.75h-1.69l-2.65-7.01c-.08-.21-.22-.3-.43-.3s-.35.09-.44.3l-2.76,7.01Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24.25,
    cy: 57.04,
    r: 1.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.34,53.39c-.24,0-.47-.05-.68-.13v6.67h1.37v-6.67c-.21.08-.44.13-.68.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 42.34,
    cy: 51.51,
    r: 1.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.55,53.39c-.24,0-.47-.05-.68-.13v6.67h1.37v-6.67c-.21.08-.44.13-.68.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 73.55,
    cy: 51.51,
    r: 1.01
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.93,50.37c-.25,0-.48-.05-.69-.14v9.7h1.37v-9.69c-.21.08-.44.13-.68.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.23,50.37c-.25,0-.48-.05-.69-.14v9.7h1.37v-9.69c-.21.08-.44.13-.68.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.09,54.43v-1.32h-1.88v-1.59c-.21.08-.43.13-.66.13-.26,0-.5-.05-.72-.14v1.6h-.93v1.32h.93v3.15c0,1.78.61,2.35,2.01,2.35h1.23v-1.25h-.94c-.64,0-.92-.26-.92-1.02v-3.23h1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.12,51.27c2.53,0,3.9,1.41,3.9,4.34s-1.36,4.32-3.9,4.32h-3.05c-.49,0-.72-.23-.72-.71v-7.25c0-.47.23-.71.72-.71h3.05ZM12.86,58.26c0,.12.05.15.17.15h2.09c1.68,0,2.39-.83,2.39-2.82s-.71-2.81-2.39-2.81h-2.09c-.12,0-.17.04-.17.15v5.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.04,51.27v1.51h-4.44c-.78,0-1.13.42-1.13,1.03,0,.53.27,1.03,1.28,1.03h2.03c2.36,0,2.91,1.31,2.91,2.55,0,1.46-.78,2.54-2.76,2.54h-4.82v-1.51h4.88c.82,0,1.19-.45,1.19-1.08,0-.56-.29-1.08-1.36-1.08h-2.01c-2.31,0-2.85-1.3-2.85-2.5,0-1.44.77-2.49,2.69-2.49h4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.51,53.16c2.3,0,3.41,1.09,3.41,2.96v3.81h-1.37v-3.81c0-1.06-.62-1.66-2.04-1.66h-2.22c-.12,0-.17.06-.17.19v5.27h-1.36v-5.72c0-.8.27-1.05.95-1.05h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.54,53.16c1.6,0,2.28.77,2.28,2.08s-.63,1.95-2.3,1.95h-3.22v.49c0,.54.29.94,1.04.94h4.14v1.32h-4.14c-1.69,0-2.36-.95-2.36-2.23v-2.31c0-1.28.67-2.23,2.36-2.23h2.19ZM59.31,56.12h3.18c.73,0,1-.31,1-.81s-.29-.85-.96-.85h-2.18c-.74,0-1.04.41-1.04.94v.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.4,53.16c1.62,0,2.49.95,2.49,2.9v3.9c0,1.92-.67,2.68-2.57,2.68h-4.03v-1.31h3.87c1.01,0,1.35-.4,1.35-1.37v-.31h-2.99c-1.81,0-2.94-1.07-2.94-3.26s1.13-3.23,2.94-3.23h1.87ZM78.65,58.42h2.86v-2.37c0-1.1-.42-1.58-1.51-1.58h-1.35c-1.17,0-1.69.59-1.69,1.98s.53,1.98,1.69,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.68,53.16c1.6,0,2.28.77,2.28,2.08s-.63,1.95-2.3,1.95h-3.22v.49c0,.54.29.94,1.04.94h4.14v1.32h-4.14c-1.69,0-2.36-.95-2.36-2.23v-2.31c0-1.28.67-2.23,2.36-2.23h2.19ZM85.45,56.12h3.18c.73,0,1-.31,1-.81s-.29-.85-.96-.85h-2.18c-.74,0-1.04.41-1.04.94v.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.87,53.16c2.3,0,3.41,1.09,3.41,2.96v3.81h-1.37v-3.81c0-1.06-.62-1.66-2.04-1.66h-2.22c-.12,0-.17.06-.17.19v5.27h-1.36v-5.72c0-.8.27-1.05.95-1.05h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.78,53.16v1.31h-3.36c-1.18,0-1.69.62-1.69,2.08s.51,2.07,1.69,2.07h3.36v1.32h-3.49c-1.81,0-2.94-1.1-2.94-3.39s1.13-3.39,2.94-3.39h3.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.29,53.16c1.6,0,2.28.77,2.28,2.08s-.63,1.95-2.3,1.95h-3.22v.49c0,.54.29.94,1.04.94h4.14v1.32h-4.14c-1.69,0-2.36-.95-2.36-2.23v-2.31c0-1.28.67-2.23,2.36-2.23h2.19ZM109.06,56.12h3.18c.73,0,1-.31,1-.81s-.29-.85-.96-.85h-2.18c-.74,0-1.04.41-1.04.94v.72Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdasIntelligenceLoginLogo);
export default __webpack_public_path__ + "static/media/adas-intelligence-login-logo.e279b94c280c9ee477f4701b21754abb.svg";
export { ForwardRef as ReactComponent };